// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3Bwzo","mail":"Footer_mail__Agx9Z"};